module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user-login/user-login.component.css
// module id = ./src/app/user-login/user-login.component.css
// module chunks = main